import BrandLoading from '../../components/ui/BrandLoading.jsx';
import HeroCarousel from '../../components/public/HeroCarousel.jsx';
import HighlightsGrid from '../../components/public/HighlightsGrid.jsx';
import NewsSection from '../../components/public/NewsSection.jsx';
import CreditosSection from '../../components/public/CreditosSection.jsx';
import HomeBenefitsBand from '../../components/public/HomeBenefitsBand.jsx';
import VacacionesSection from '../../components/public/VacacionesSection.jsx';
import { usePublicContent } from '../../hooks/usePublicContent.js';
import publicCta from '../../content/publicCta.json';
import { BellRing, Briefcase, ClipboardList, UserRoundPen } from 'lucide-react';

const ICON_MAP = {
  UserRoundPen,
  ClipboardList,
  BellRing,
  Briefcase,
};

export default function LandingPage() {
  const { carrusel, noticias, creditos, convenios, vacaciones, loading, error } = usePublicContent();

  const highlights = publicCta.highlights.map((h) => ({
    ...h,
    icon: ICON_MAP[h.icon] || UserRoundPen,
  }));

  if (loading) {
    return <BrandLoading variant="fullscreen" label="Cargando contenido…" />;
  }

  return (
    <div className="overflow-x-hidden">
      <HeroCarousel slides={carrusel} loading={false} />

      <HighlightsGrid items={highlights} />

      {error && (
        <div className="mx-auto max-w-7xl px-6 py-6 lg:px-8">
          <div className="rounded-xl border border-red-500/40 bg-red-950/50 px-4 py-3 text-sm text-red-200">{error}</div>
        </div>
      )}

      <NewsSection items={(noticias ?? []).slice(0, 3)} loading={false} />
      <CreditosSection items={(creditos ?? []).slice(0, 3)} loading={false} waveFromDark />
      <HomeBenefitsBand convenios={convenios} loading={false} />
      <VacacionesSection items={vacaciones} loading={false} variant="green" waveFromDark />
    </div>
  );
}
